import React, { Component } from 'react';
import './Divider.css';

const Divider = (props) => {
  return (
    <div className="divider" />
  );
};

export default Divider;



// WEBPACK FOOTER //
// ./src/Divider/Divider.js